import { Text } from '@cellula/react';
import { VStack } from '@components/v_stack.component';
import { FlexibleListModel } from '@services/flexible_component/mod';
import styled from 'styled-components';
import { FlexibleIdentifier } from './flexible_identifier.component';

interface Props {
	component: FlexibleListModel;
}

const elements = {
	container: styled.div`
		display: flex;
		flex-direction: column;
	`,
};

export function FlexibleList({ component }: Props): JSX.Element {
	return (
		<elements.container data-testid='FlexibleList'>
			{component.title && <Text variant='bodySmallRegular'>{component.title}</Text>}
			<VStack>
				{component.items.map((item) => (
					<FlexibleIdentifier key={item.id} component={item} />
				))}
			</VStack>
		</elements.container>
	);
}
